import SrInputNumber from '@/components/SrInputNumber.vue'
import MultiSelect from 'primevue/multiselect'
import Select from 'primevue/select'
import { AVAILABLE_DEXCHANGES } from '@/utils/consts'
import { i18n } from '@/i18n'
import { markRaw } from 'vue'
import { z } from 'zod'
import InputText from 'primevue/inputtext'
import isString from 'lodash/isString'

export function createDexCexFilters() {
  const { t } = i18n.global
  const dexCexFilters = [
    // {
    //   header: 'dexs',
    //   field: 'dexs',
    //   component: markRaw(InputText),
    //   placeholder: 'Pancake, Raydium...',
    //   zod: z.string().optional().nullable(),
    // },
    {
      field: 'cexs',
      header: 'cexs',
      component: markRaw(MultiSelect),
      placeholder: 'Gate, Mexc, Bingx, Bitget...',
      zod: z.string().array().optional().nullable(),
      props: {
        filterMatchMode: 'startsWith',
        showClear: true,
        options: AVAILABLE_DEXCHANGES,
        optionLabel: 'title',
        optionValue: 'value',
        filter: true,
        emptyFilterMessage: t('emptyMessage'),
      },
    },
    {
      field: 'symbols',
      header: 'symbols',
      component: markRaw(InputText),
      placeholder: 'BTC, BNB, SOL...',
      zod: z.string().optional().nullable(),
    },
    {
      field: 'excludeSelectedSymbols',
      header: 'symbolsFilterMode',
      component: markRaw(Select),
      zod: z.boolean().nullable().optional(),
      get props() {
        return {
          options: [
            {
              label: t('filters.excludeSelected'),
              value: true,
            },
            {
              label: t('filters.showSelected'),
              value: false,
            },
          ],
          optionLabel: 'label',
          optionValue: 'value',
          showToggleAll: false,
          emptyFilterMessage: t('emptyMessage'),
        }
      },
    },
    {
      field: 'isLong',
      header: 'direction',
      component: markRaw(Select),
      zod: z.number().nullable().optional(),
      get props() {
        return {
          options: [
            {
              label: t('filters.vol24None'),
              value: 0,
            },
            {
              label: 'CEX-DEX',
              value: 1,
            },
            {
              label: 'DEX-CEX',
              value: 2,
            },
          ],
          optionLabel: 'label',
          optionValue: 'value',
          showToggleAll: false,
          emptyFilterMessage: t('emptyMessage'),
        }
      },
    },
    // {
    //   field: 'volumes',
    //   header: 'volumesRatio',
    //   component: markRaw(Select),
    //   zod: z.number().nullable().optional(),
    //   get props() {
    //     return {
    //       options: [
    //         {
    //           label: t('filters.vol24None'),
    //           value: 0,
    //         },
    //         {
    //           label: t('filters.dexFollowsCex'),
    //           value: 2,
    //         },
    //         {
    //           label: t('filters.cexFollowsDex'),
    //           value: 1,
    //         },
    //       ],
    //       optionLabel: 'label',
    //       optionValue: 'value',
    //       showToggleAll: false,
    //       emptyFilterMessage: t('emptyMessage'),
    //     }
    //   },
    // },
    {
      field: 'spreadMin',
      header: 'spreadMin',
      component: markRaw(SrInputNumber),
      placeholder: '2.00',
      zod: z.preprocess(
        (x: string | null) => (isString(x) && x.trim() === '' ? null : Number(x)),
        z.number().nullable(),
      ),
      props: {
        step: 0.5,
        showButtons: true,
        maxFractionDigits: 2,
      },
    },
    {
      field: 'vol24hCexMin',
      header: 'vol24hCexMin',
      component: markRaw(Select),
      zod: z.number().nullable().optional(),
      get props() {
        return {
          options: [
            {
              label: t('filters.vol24None'),
              value: 0,
            },
            {
              label: t('filters.vol24_200k'),
              value: 200000,
            },
            {
              label: t('filters.vol24_500k'),
              value: 500000,
            },
            {
              label: t('filters.vol24_1kk'),
              value: 1000000,
            },
          ],
          optionLabel: 'label',
          optionValue: 'value',
          showToggleAll: false,
          emptyFilterMessage: t('emptyMessage'),
        }
      },
    },
    {
      field: 'vol24hDexMin',
      header: 'vol24hDexMin',
      component: markRaw(Select),
      zod: z.number().nullable().optional(),
      get props() {
        return {
          options: [
            {
              label: t('filters.vol24None'),
              value: 0,
            },
            {
              label: t('filters.vol24_10k'),
              value: 10000,
            },
            {
              label: t('filters.vol24_50k'),
              value: 50000,
            },
            {
              label: t('filters.vol24_100k'),
              value: 100000,
            },
            {
              label: t('filters.vol24_500k'),
              value: 500000,
            },
            {
              label: t('filters.vol24_1kk'),
              value: 1000000,
            },
          ],
          optionLabel: 'label',
          optionValue: 'value',
          showToggleAll: false,
          emptyFilterMessage: t('emptyMessage'),
        }
      },
    },
    {
      field: 'maxAgeSeconds',
      header: 'timeAgo',
      component: markRaw(Select),
      zod: z.number().nullable().optional(),
      get props() {
        return {
          options: [
            { label: t('filters.vol24None'), value: 0 },
            { label: t('filters.time1min'), value: 60 },
            { label: t('filters.time5min'), value: 300 },
            { label: t('filters.time15min'), value: 900 },
            { label: t('filters.time30min'), value: 1800 },
            { label: t('filters.time1h'), value: 3600 },
          ],
          optionLabel: 'label',
          optionValue: 'value',
          showToggleAll: false,
          emptyFilterMessage: t('emptyMessage'),
        }
      },
    },
  ]
  return dexCexFilters
}
